import webCore from '@happylife-a/web-core';

export function stripLocale(pathname) {
  const { available } = webCore.contexts.useTranslation();

  const parts = pathname.split('/');
  if (available?.includes(parts[1])) {
    return '/' + parts.slice(2).join('/');
  }
  return pathname;
}
